<template>
  <div class="flex px-40 py-25">
    <div class="half-width">
      <span class="subheading-3 pb-8">Categories</span>
      <div class="flex flex-wrap">
        <span
          v-for="category in categories.children_containers"
          :key="category.id"
          class="third-width py-8 a2 pointer category-link"
          @click="navigateToCategory(category)"
        >
          <span :class="{ active: isActive(category) }">{{ category.name }}</span>
        </span>
      </div>
    </div>
    <div class="half-width">
      <span class="subheading-3">Collections</span>
      <div class="flex">
        <div
          v-for="(collection, index) in collections.view_components"
          :key="collection.id"
          class="collection-container"
          @click="handleCollectionClick(collection)"
        >
          <img
            class="collection-image"
            :class="{
              'top-rounded': index === 1,
              rounded: index === 2
            }"
            :src="collection.info.image_url"
            :alt="collection.info.name"
          />
          <span class="a2 mt-15 pointer">{{ collection.info.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navigationHelper } from '../mixin/navigationHelper'
import { mapGetters } from 'vuex'

export default {
  name: 'AllCategoriesMenu',
  mixins: [navigationHelper],
  computed: {
    ...mapGetters({
      categories: 'navigation/navigationCategories',
      collections: 'navigation/navigationCollections'
    })
  },
  methods: {
    handleCollectionClick,
    isActive
  }
}

function handleCollectionClick(collection) {
  if (collection.info.collection_type === 'collection') {
    this.$router.push({
      name: 'Collection',
      params: {
        collectionName: collection.info.collection_name,
        collectionId: collection.entity_id
      },
      query: { page: 1 }
    })
  } else {
    window.open(collection.info.url, '_self')
  }
}

function isActive({ name, id }) {
  return this.$route.params.navItemName === name && this.$route.params.navItemId === id
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/base/_vars.scss';
@import '@/assets/sass/base/_mixins.scss';

.category-link {
  .active {
    background: linear-gradient(0deg, $color-green 40%, transparent 50%);
  }
  &:hover {
    cursor: pointer;
    color: $color-grey-4;
  }
}

.collection {
  &-container {
    display: flex;
    flex-direction: column;
    padding: 16px 8px;
    width: 33%;
    &:hover {
      opacity: 0.7;
    }
  }
  &-image {
    aspect-ratio: 0.9 / 1;
    border: 1px solid $color-black;
    cursor: pointer;
    &.rounded {
      border-radius: 16px;
    }
    &.top-rounded {
      border-top-left-radius: 50%;
      border-top-right-radius: 50%;
    }
  }
}
</style>
